import {} from 'viem';
import { assertRequest } from 'viem/utils';
import {} from 'viem/zksync';
import { InvalidEip712TransactionError } from './errors/eip712.js';
export function isEIP712Transaction(transaction) {
    if (transaction.type === 'eip712')
        return true;
    if (('customSignature' in transaction && transaction.customSignature) ||
        ('paymaster' in transaction && transaction.paymaster) ||
        ('paymasterInput' in transaction && transaction.paymasterInput) ||
        ('gasPerPubdata' in transaction &&
            typeof transaction.gasPerPubdata === 'bigint') ||
        ('factoryDeps' in transaction && transaction.factoryDeps))
        return true;
    return false;
}
export function assertEip712Request(args) {
    if (!isEIP712Transaction(args))
        throw new InvalidEip712TransactionError();
    assertRequest(args);
}
//# sourceMappingURL=eip712.js.map